<template>
	<form
		class="flex flex-col md:gap-12 pt-12"
		@submit="submitConsentForm"
	>
		<MoreInfo
			v-if="isMoreInfoOpen"
			@close="isMoreInfoOpen = false"
		/>
		<Settings v-else-if="isAdvancedSettingsOpen" />
		<p
			v-else
			class="mb-0 text-paragraph-size-sm md:text-paragraph-size-md"
		>
			Wij gebruiken cookies om jouw ervaring te verbeteren. Functionele en analytische cookies zorgen dat
			onze website goed werkt en we inzicht krijgen in het gebruik. Met jouw toestemming gebruiken we ook
			marketingcookies om je relevante en persoonlijke aanbiedingen te laten zien. Sta je dit toe?
		</p>
		<div
			class="sticky bottom-0 flex flex-col md:flex-row justify-between gap-8 md:gap-12 bg-purple-900 py-8"
		>
			<div
				class="flex gap-12"
			>
				<AtomButton
					v-if="!isAdvancedSettingsOpen"
					type="button"
					:text="isMoreInfoOpen ? 'Sluiten' : 'Cookie beleid en partners'"
					:icon-left="isMoreInfoOpen ? 'fa-xmark' : 'fa-circle-question'"
					:variant="ButtonVariant.Transparent"
					@click="isMoreInfoOpen = !isMoreInfoOpen"
				/>
				<AtomButton
					v-if="!isMoreInfoOpen"
					type="button"
					class="text-nowrap"
					:text="
						isAdvancedSettingsOpen
							? 'Instellingen sluiten'
							: 'Instellingen'
					"
					:icon-left="isAdvancedSettingsOpen ? 'fa-xmark' : 'fa-gears'"
					:variant="ButtonVariant.Transparent"
					@click="isAdvancedSettingsOpen = !isAdvancedSettingsOpen"
				/>
			</div>

			<AtomButton
				type="submit"
				class="text-nowrap"
				:variant="ButtonVariant.Green"
				icon-left="fa-check"
				:text="
					isAdvancedSettingsOpen
						? 'Opslaan en doorgaan'
						: 'Accepteren en doorgaan'
				"
			/>
		</div>
	</form>
</template>

<script setup lang="ts">
import MoreInfo from './MoreInfo.vue';
import Settings from './Settings.vue';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const {
	submitConsentSettings,
} = useConsent();

const isAdvancedSettingsOpen = ref<boolean>(false);
const isMoreInfoOpen = ref<boolean>(false);

const submitConsentForm = (e: Event) => {
	e.preventDefault();

	submitConsentSettings();
};
</script>
